
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"bankInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BankInfo"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountHolderName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountNumberLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountNumberLastFour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bankName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"routingNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"source"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"externalConnectionGuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":184}};
    doc.loc.source = {"body":"fragment bankInfoFragment on BankInfo {\n  id\n  accountHolderName\n  accountNumberLength\n  accountNumberLastFour\n  bankName\n  routingNumber\n  source\n  externalConnectionGuid\n  logoUrl\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
